module.exports = __webpack_public_path__ + "img/01-1首页.9703452a.png";